import React, { useEffect, useRef, useState } from "react"

import { useSelector } from "react-redux"
import { FILTER_TYPE } from "../../util/filters/filterConstants"
import { FilterManager } from "../../util/filters/filterManager"
import CustomTableContainer from "../Common/Table/CustomTableContainer"
import DeviceClearModal from "./modals/deviceClear"

export default function AllDevices() {
  const [processedDevices, setProcessedDevices] = useState([])
  const devices = useSelector((state) => state.internal.devices)

  const [modalData, setModalData] = useState({ open: false })

  const filterManagerRef = useRef(null)
  if (!filterManagerRef.current) {
    filterManagerRef.current = FilterManager.Builder.addFilter(FILTER_TYPE.DEVICE.ID, true)
      .addFilter(FILTER_TYPE.DEVICE.NAME, false)
      .addFilter(FILTER_TYPE.DEVICE.ORIGINAL_NAME, true)
      .addFilter(FILTER_TYPE.DEVICE.LAST_SEEN, true)
      .addFilter(FILTER_TYPE.DEVICE.LATITUDE, false)
      .addFilter(FILTER_TYPE.DEVICE.LONGITUDE, false)
      .addFilter(FILTER_TYPE.DEVICE.CYCLE_TIME, false)
      .addFilter(FILTER_TYPE.DEVICE.TRIGGER_NUMBER, false)
      .addFilter(FILTER_TYPE.DEVICE.MEMORY_REMAINING, false)
      .addFilter(FILTER_TYPE.DEVICE.CYCLE_COUNT, false)
      .addFilter(FILTER_TYPE.DEVICE.IMAGES_PROCESSED, false)
      .addFilter(FILTER_TYPE.DEVICE.WIFI_IMAGES, false)
      .addFilter(FILTER_TYPE.DEVICE.WIFI_INSIGHTS, false)
      .addFilter(FILTER_TYPE.DEVICE.LORA_ID, false)
      .addFilter(FILTER_TYPE.DEVICE.CODE_VERSION, false)
      .addFilter(FILTER_TYPE.DEVICE.MAC_ID, true)
      .addFilter(FILTER_TYPE.DEVICE.MCU_VERISON, true)
      .addFilter(FILTER_TYPE.DEVICE.CELL_UID, false)
      .build()
  }
  const filterManager = filterManagerRef.current

  const handleClick = (_, row) => {
    const newModalData = {
      open: true,
      deviceId: row.device_id,
    }
    setModalData(newModalData)
  }

  const handleClose = () => {
    setModalData({ open: false })
  }

  useEffect(() => {
    if (devices) {
      setProcessedDevices(
        devices.map((device, index) => {
          return {
            ...filterManager.generateDataMap(device),
            id: index,
          }
        }),
      )
    }
  }, [devices, filterManager.generateDataMap])

  return (
    <>
      <CustomTableContainer
        defaultOrder="desc"
        defaultOrderHeader={FILTER_TYPE.DEVICE.ID}
        headers={filterManager.getHeaders()}
        filterManager={filterManager}
        rowData={processedDevices}
        paginationOptions={[5, 10, 25, 50, 100]}
        defaultPaginationOption={25}
        clickAction={handleClick}
      />
      {modalData?.deviceId && (
        <DeviceClearModal
          deviceId={modalData.deviceId}
          open={modalData.open}
          handleClose={handleClose}
        />
      )}
    </>
  )
}
